import React, { useState, useEffect } from "react";

const Countdown = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    dias: 0,
    horas: 0,
    minutos: 0,
    segundos: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +new Date(targetDate) - +new Date();
      
      if (difference > 0) {
        setTimeLeft({
          dias: Math.floor(difference / (1000 * 60 * 60 * 24)),
          horas: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutos: Math.floor((difference / 1000 / 60) % 60),
          segundos: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="flex justify-center gap-6 md:gap-8 flex-wrap">
      {Object.entries(timeLeft).map(([label, value]) => (
        <div
          key={label}
          className="bg-white/20 backdrop-blur-md rounded-2xl p-6 md:p-8 min-w-[100px] md:min-w-[140px] text-center border border-white/30 shadow-xl"
          data-testid={`countdown-${label}`}
        >
          <div className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">{value}</div>
          <div className="text-sm md:text-lg uppercase tracking-wider text-white/90 mt-2 font-semibold">{label}</div>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
